{
  "aviator.service-health-dashboard.app-status-spotlight.action.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step-counter": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step1.body": [
    {
      "type": 0,
      "value": "View active incidents, maintenance events and their details."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step1.heading": [
    {
      "type": 0,
      "value": "Track current events"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step2.body": [
    {
      "type": 0,
      "value": "Search and filter past incidents and maintenance events."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step2.heading": [
    {
      "type": 0,
      "value": "Browse event history"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step3.body": [
    {
      "type": 0,
      "value": "View which app experiences across app instances are currently impacted."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step3.heading": [
    {
      "type": 0,
      "value": "Check experience status"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step4.body": [
    {
      "type": 0,
      "value": "Get an overview of how events affect your apps and their experiences."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step4.heading": [
    {
      "type": 0,
      "value": "Review impact on apps"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step-counter": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step1.body": [
    {
      "type": 0,
      "value": "View the current status and recent events for each app in your organization."
    }
  ],
  "aviator.service-health-dashboard.spotlight.step1.heading": [
    {
      "type": 0,
      "value": "Dive into app status"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step2.body": [
    {
      "type": 0,
      "value": "Stay informed about incidents and maintenance events in your organization"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step2.heading": [
    {
      "type": 0,
      "value": "Subscribe to updates"
    }
  ]
}